{
  "meta": {
    "theme_toggle_aria": "Cambiar tema"
  },
  "nav": {
    "features": "Funciones",
    "product": "Producto",
    "pricing": "Precios",
    "faq": "FAQ",
    "login": "Entrar",
    "register": "Empezar gratis",
    "my_account": "Mi cuenta"
  },
  "hero": {
    "eyebrow_pill": "Nuevo",
    "eyebrow_text": "Reuniones con IA — transcripción y resumen automático",
    "title_1": "Donde",
    "title_2": "los",
    "title_3": "equipos",
    "title_4": "brillantes",
    "title_5": "construyen",
    "title_6": "cosas",
    "title_7": "reales.",
    "sub_html": "Tareas, proyectos, chat en vivo y <strong>reuniones con IA</strong> en un solo lienzo. Graba, deja que la IA transcriba y resuma — y convierte cada acuerdo en tarea con un click.",
    "cta_register": "Empezar gratis — 14 días Pro",
    "cta_account": "Ir a mi cuenta",
    "cta_see_product": "Ver el producto",
    "download_play": "Descárgala en Google Play",
    "download_play_meta": "Android",
    "download_play_title": "Descargar Tworks para Android desde Google Play",
    "meta_no_card": "Sin tarjeta de crédito",
    "meta_setup": "Setup en 2 minutos",
    "meta_cancel": "Cancelas cuando quieras",
    "sticker_completed": "Tarea completada",
    "sticker_completed_meta": "hace un momento",
    "sticker_comment": "Andrea acaba de comentar",
    "sticker_comment_meta": "\"Aprobado ✅ vamos a dev\"",
    "url_bar": "app.pavemi.com / reuniones / daily-standup",
    "sidebar_space": "Espacio",
    "sidebar_work": "Trabajo",
    "sidebar_home": "Inicio",
    "sidebar_my_tasks": "Mis tareas",
    "sidebar_inbox": "Bandeja",
    "sidebar_projects": "Proyectos",
    "sidebar_project_1": "Rediseño landing",
    "sidebar_project_2": "Campaña Q2",
    "sidebar_project_3": "Backend infra",
    "demo_aria": "Demo animada de la feature de reuniones con IA",
    "demo_title": "Daily standup — equipo producto",
    "demo_meta": "Reunión · 14:30",
    "record_btn": "Grabar reunión",
    "transcript_a_text": "Hay que cerrar la integración con Stripe esta semana.",
    "transcript_m_text": "Yo me encargo del webhook de invoices.",
    "transcript_s_text": "Necesitamos QA del flujo de upgrade antes del viernes.",
    "tasks_label": "Tareas auto-creadas",
    "task_1": "Cerrar integración con Stripe",
    "task_2": "Implementar webhook de invoices",
    "task_3": "QA del flujo de upgrade"
  },
  "demo_video": {
    "title_html": "Mira Tworks en <em>60 segundos</em>",
    "subtitle": "Lo esencial: reuniones con IA, kanban colaborativo, y todo el flujo de trabajo en un solo lienzo.",
    "unsupported": "Tu navegador no soporta video HTML5."
  },
  "marquee": [
    "Reemplaza Asana, Trello y Notion",
    "Reuniones que se transcriben solas",
    "Resumen IA por proyecto",
    "Encriptado end-to-end",
    "\"Mi equipo dejó de pelearse en Slack\""
  ],
  "features": {
    "kicker": "01 — Funciones",
    "title_html": "Todo lo que tu equipo necesita,<br><em>sin lo que no.</em>",
    "sub": "Deja de saltar entre seis apps. Tworks integra lo esencial en una sola superficie cuidadosamente diseñada.",
    "kanban_title_html": "Tablero <em>Kanban</em>",
    "kanban_body": "Arrastra y suelta entre columnas. Visualiza el flujo de tu equipo sin abrir cinco pestañas.",
    "kanban_col_pending": "Pendiente",
    "kanban_col_in_progress": "En curso",
    "kanban_col_done": "Listo",
    "kanban_card_1": "Maqueta hero",
    "kanban_card_2": "Bug CSS",
    "kanban_card_3": "Auth API",
    "kanban_card_4": "Setup",
    "calendar_title_html": "Vista <em>Calendario</em>",
    "calendar_body": "Planifica entregas y deadlines visualmente. Drag & drop para reprogramar.",
    "calendar_month": "Abril",
    "calendar_week": "Semana 17",
    "ai_title_html": "Reuniones con <em>IA</em>",
    "ai_body": "Graba desde el navegador. La IA transcribe y resume — luego conviertes cada acuerdo en tarea con un click.",
    "ai_recording": "Grabando",
    "ai_quote": "\"Andrea va a preparar el deck para el viernes…\"",
    "chat_title_html": "Chat <em>en vivo</em>",
    "chat_body": "Cada tarea es un mini-chat. {'@'}menciones, archivos, todo en contexto.",
    "chat_msg_1_name": "Andrea",
    "chat_msg_1_text": "Subí el deck del cliente 📊",
    "chat_msg_2_name": "Marco",
    "chat_msg_2_text_html": "<span class=\"mention\">{'@'}Andrea</span> revisado, listo",
    "notif_title_html": "Notificaciones <em>limpias</em>",
    "notif_body": "Solo lo que te involucra. No el ruido de toda la organización.",
    "notif_1_html": "<strong>Marco</strong> te asignó <strong>\"Revisar PR #247\"</strong>",
    "notif_1_time": "hace 2 min",
    "notif_2_html": "<strong>Andrea</strong> te mencionó en <strong>\"Deck cliente\"</strong>",
    "notif_2_time": "hace 1 h",
    "closer_title_html": "Construido para que <em>todo</em> esté en su lugar.",
    "closer_body": "Vista Timeline, reportes ejecutivos, equipos y departamentos, dark mode, búsqueda global, adjuntos hasta 100MB, subtareas, tags, atajos de teclado. Cada detalle pensado para no estorbar.",
    "tag_timeline": "Timeline",
    "tag_reports": "Reportes",
    "tag_ai_summary": "Resumen IA",
    "tag_multi_team": "Multi-equipo",
    "tag_departments": "Departamentos",
    "tag_subtasks": "Subtareas",
    "tag_attachments": "Adjuntos",
    "tag_tags": "Tags",
    "tag_global_search": "Búsqueda global",
    "tag_palette": "⌘K palette",
    "tag_dark": "Dark mode",
    "tag_pwa": "PWA",
    "tag_sso": "Google SSO"
  },
  "showcase": {
    "kicker": "02 — Producto",
    "title_html": "Mira <em>cómo se ve</em> trabajar mejor.",
    "task_detail": {
      "kicker": "Detalle de tarea",
      "title_html": "El contexto <em>nunca</em> se pierde.",
      "body": "Comentarios, asignados, fechas, etiquetas, adjuntos y subtareas — todo en un solo panel. Lo que antes vivía disperso entre Slack, Drive y emails ahora está donde tiene que estar: junto al trabajo.",
      "li_1_html": "<strong>Chat en tiempo real</strong> vía WebSocket — ves cuando alguien escribe",
      "li_2_html": "<strong>{'@'}menciones</strong> que notifican al instante",
      "li_3_html": "<strong>Adjuntos hasta 100 MB</strong> — drag & drop directo",
      "link": "Pruébalo en tu equipo",
      "annot": "Tarea con todo el contexto",
      "url": "tarea / Diseñar componentes del hero",
      "breadcrumb": "REDISEÑO LANDING / DISEÑO",
      "task_title": "Diseñar componentes del hero",
      "status": "En progreso",
      "comments_label": "Comentarios · 3",
      "comment_1_name": "Andrea",
      "comment_1_time": "10:24",
      "comment_1_text": "Avancé con dos versiones del hero. La A es más editorial, la B más clásica.",
      "comment_2_name": "Marco",
      "comment_2_time": "10:28",
      "comment_2_text_html": "<span class=\"mention\">{'@'}Andrea</span> me quedo con la A. Vamos por esa.",
      "comment_3_name": "Sindy",
      "comment_3_time": "ahora",
      "comment_3_text_html": "Aprobado ✅. <span class=\"mention\">{'@'}Marco</span> ya podemos pasar a dev.",
      "field_assignees": "Asignados",
      "field_due": "Fecha límite",
      "field_due_value": "29 abr",
      "field_priority": "Prioridad",
      "field_priority_value": "Alta",
      "field_tags": "Etiquetas",
      "field_tag_1": "Diseño",
      "field_tag_2": "Hero",
      "field_attachments": "Adjuntos"
    },
    "ai_meetings": {
      "kicker": "Reuniones con IA",
      "title_html": "De voz a tareas, <em>sin tomar notas.</em>",
      "body": "Graba directo desde el navegador o sube un audio. Whisper transcribe en minutos y un resumen ejecutivo extrae acuerdos, decisiones y próximos pasos. Revisa, edita y convierte cada acción en una tarea asignada.",
      "li_1_html": "<strong>Transcripción precisa</strong> con Whisper-large-v3",
      "li_2_html": "<strong>Resumen estructurado</strong>: temas, decisiones, próximos pasos",
      "li_3_html": "<strong>Tareas con un click</strong> — revisas y comprometes",
      "li_4_html": "Audio con <strong>retención auto</strong> (90 días) y borrado seguro",
      "annot": "Listo para revisar",
      "url": "app.pavemi.com / reuniones / sync-q2",
      "meeting_title": "Sync Q2",
      "meeting_meta": "28 abr · 32 min",
      "transcript_label": "Transcripción",
      "transcript_a_html": "<strong style=\"color:var(--teal-2);\">Andrea —</strong> El deck del cliente lo cierro el viernes. Necesito que Marco apruebe la sección de pricing antes del jueves.",
      "transcript_m_html": "<strong style=\"color:var(--amber-2);\">Marco —</strong> De acuerdo. Si llega el jueves a primera hora lo reviso ese día.",
      "transcript_s_html": "<strong style=\"color:var(--ink-2);\">Sindy —</strong> Yo voy a coordinar la demo con producto el martes a las 10.",
      "summary_label": "Resumen IA",
      "summary_text": "Sync de status Q2: cierre de deck cliente, alineación de pricing y demo con producto.",
      "tasks_label_html": "Tareas propuestas <span style=\"color:var(--teal-2)\">· 3</span>",
      "task_1": "Cerrar deck cliente",
      "task_2": "Aprobar sección pricing",
      "task_3": "Coordinar demo producto",
      "confirm_button": "Confirmar 3 tareas"
    },
    "calendar": {
      "kicker": "Calendario",
      "title_html": "De lista de tareas a <em>plan ejecutable.</em>",
      "body": "Ubica cada tarea en el calendario. Mira de un vistazo qué viene esta semana y dónde se acumula la carga. Reasigna fechas con drag & drop.",
      "li_1_html": "Vista <strong>mes, semana</strong>",
      "li_2_html": "<strong>Drag & drop</strong> para reprogramar",
      "li_3_html": "Alertas de <strong>vencimiento</strong> automáticas",
      "annot": "Hoy resaltado",
      "url": "app.pavemi.com / calendario",
      "month": "Abril 2026",
      "tab_month": "Mes",
      "tab_week": "Semana",
      "tab_list": "Lista",
      "dow_mon": "Lun",
      "dow_tue": "Mar",
      "dow_wed": "Mié",
      "dow_thu": "Jue",
      "dow_fri": "Vie",
      "dow_sat": "Sáb",
      "dow_sun": "Dom",
      "event_1": "Brief cliente",
      "event_2": "Demo 14:00",
      "event_3": "Deadline Q2",
      "event_4": "Review",
      "event_5": "Hero v2",
      "event_6": "Sync"
    },
    "my_tasks": {
      "kicker": "Mis tareas",
      "title_html": "Tu día. Tu ritmo. <em>Tu enfoque.</em>",
      "body": "\"Mis tareas\" agrupa todo lo que tienes asignado en un solo lugar — independiente del proyecto. Ordena por prioridad o fecha. Termina con un click.",
      "li_1_html": "Tareas <strong>standalone</strong> (sin proyecto) — para lo personal",
      "li_2_html": "Una tarea, <strong>varios proyectos</strong>",
      "li_3_html": "Atajos de teclado en todas partes",
      "annot": "Click para completar",
      "url": "app.pavemi.com / mis-tareas",
      "greeting": "Buen día, Leo",
      "subtitle_html": "Tienes <strong style=\"color: var(--teal-2)\">6 tareas</strong> esta semana",
      "today_label": "Hoy",
      "task_done": "Configurar entorno de desarrollo",
      "task_done_tag": "Backend",
      "task_1": "Implementar autenticación OAuth",
      "task_1_tag": "Alta",
      "task_2": "Diseñar dashboard de métricas",
      "task_2_tag": "Media",
      "tomorrow_label": "Mañana",
      "task_3": "Revisar PR #247 — API endpoints",
      "task_3_tag": "Alta",
      "task_4": "Escribir tests de integración",
      "task_4_tag": "Media"
    }
  },
  "pricing": {
    "kicker": "03 — Precios",
    "title_html": "Simple. <em>Honesto.</em><br>Sin sorpresas.",
    "sub": "Empieza gratis. Desbloquea Pro cuando tu equipo crezca. Cancelas cuando quieras.",
    "free_name": "Free",
    "free_tag": "Para empezar y proyectos personales",
    "free_per": "/ siempre",
    "free_feat_1_html": "Hasta <strong>10 miembros</strong>",
    "free_feat_2_html": "<strong>1000 tareas</strong> activas",
    "free_feat_3_html": "Vistas <strong>Kanban + Lista</strong>",
    "free_feat_4": "Chat en vivo + adjuntos (10 MB/archivo)",
    "free_feat_5_html": "<strong>500 MB</strong> almacenamiento",
    "free_feat_6": "Notificaciones in-app",
    "free_cta": "Empezar gratis",
    "free_cta_in": "Ir a mi cuenta",
    "pro_badge": "14 días gratis",
    "pro_name": "Pro",
    "pro_tag": "IA + reuniones inteligentes para equipos en crecimiento",
    "pro_per": "/ workspace / mes",
    "pro_feat_1_html": "<strong>5 asientos incluidos</strong> · $4 por asiento extra",
    "pro_feat_2_html": "<strong>Reuniones con IA</strong> · 600 min/mes (hasta 2h por reunión)",
    "pro_feat_3_html": "<strong>Resumen IA</strong> ejecutivo por proyecto",
    "pro_feat_4_html": "Vistas <strong>Calendario y Timeline</strong>",
    "pro_feat_5": "Reportes y dashboards",
    "pro_feat_6_html": "<strong>20 GB</strong> · adjuntos hasta 100 MB",
    "pro_feat_7": "Time tracking · Tags · Campos personalizados",
    "pro_cta": "Probar 14 días gratis",
    "pro_cta_in": "Ver mi plan",
    "business_name": "Business",
    "business_tag": "IA sin límites + control empresarial",
    "business_feat_1_html": "<strong>Todo lo de Pro</strong> con 15 asientos incluidos, además:",
    "business_feat_2_html": "<strong>3000 min/mes</strong> de reuniones IA (hasta 4h por reunión)",
    "business_feat_3_html": "<strong>100 GB</strong> · adjuntos hasta 500 MB",
    "business_feat_4": "Portafolios, metas y carga de trabajo",
    "business_feat_5": "Aprobaciones e invitados externos",
    "business_feat_6": "SSO · API pública · Webhooks",
    "business_feat_7": "Soporte prioritario",
    "business_cta": "Hablar con ventas",
    "note": "Pago anual disponible (2 meses gratis). Cancelas cuando quieras — al cancelar Pro, vuelves a Free sin perder datos."
  },
  "faq": {
    "kicker": "04 — Preguntas",
    "title_html": "Lo que <em>seguramente</em><br>te estás preguntando.",
    "q1": "¿Necesito tarjeta de crédito para empezar?",
    "a1": "No. El plan Free es para siempre y sin tarjeta. Al registrarte recibes 14 días de Pro automáticamente — al vencer, tu cuenta vuelve a Free sin cobros y sin perder datos.",
    "q2": "¿Cómo funcionan las reuniones con IA?",
    "a2": "Grabas desde el navegador (o subes un audio). Tworks transcribe con Whisper-large-v3 y genera un resumen estructurado: temas, decisiones y próximos pasos. Tú revisas, editas y conviertes los acuerdos en tareas asignadas con un click. El audio se borra automáticamente a los 90 días por defecto. Pro: 600 minutos/mes, hasta 2h por reunión. Business: 3000 min/mes, hasta 4h.",
    "q3": "¿Puedo importar mis tareas de Asana o Trello?",
    "a3": "Sí. Soportamos importación CSV y JSON desde las herramientas más comunes. Para migraciones grandes, te ayudamos personalmente sin costo.",
    "q4": "¿Mis datos están seguros?",
    "a4": "Encriptación TLS 1.3 en tránsito y AES-256 en reposo. Backups diarios automáticos. Hosting en infraestructura SOC 2 Type II. Y siempre puedes exportar todo en formato abierto.",
    "q5": "¿Funciona offline?",
    "a5": "Lectura sí, vía cache local. La escritura requiere conexión — para mantener todo sincronizado en tiempo real entre dispositivos.",
    "q6": "¿Hay app móvil?",
    "a6": "Sí. Tworks para Android ya está en Google Play — gratis, con la misma cuenta. En iPhone y iPad instala la web app desde Safari (Compartir → Añadir a pantalla de inicio); la app nativa de iOS está en camino."
  },
  "big_cta": {
    "title_html": "Deja de gestionar caos.<br>Empieza a <em>construir.</em>",
    "sub": "Únete a cientos de equipos que ya usan Tworks para entregar más, con menos estrés y más enfoque.",
    "register": "Crear mi cuenta gratis",
    "account": "Ir a mi cuenta",
    "see_product": "Ver el producto"
  },
  "footer": {
    "brand_sub": "El espacio de trabajo donde los equipos brillantes construyen cosas reales.",
    "product_col": "Producto",
    "product_features": "Funciones",
    "product_demo": "Demo",
    "product_pricing": "Precios",
    "product_changelog": "Changelog",
    "account_col": "Cuenta",
    "account_register": "Registro",
    "account_login": "Iniciar sesión",
    "account_my": "Mi cuenta",
    "account_billing": "Mi plan",
    "account_faq": "FAQ",
    "account_contact": "Contacto",
    "legal_col": "Legal",
    "legal_privacy": "Privacidad",
    "legal_terms": "Términos",
    "legal_security": "Seguridad",
    "copyright": "© 2026 Tworks · Hecho con cuidado en Honduras 🇭🇳",
    "tagline": "— el caos no es un sistema —"
  },
  "privacy": {
    "title": "Política de privacidad",
    "last_updated": "Última actualización: 1 de agosto de 2026",
    "intro": "Esta política describe cómo Tworks, operado por Moniteck, recolecta, usa y protege tus datos cuando utilizas nuestra aplicación de gestión de proyectos y tareas, tanto en la web como en las apps para Android e iOS. Al crear una cuenta o usar Tworks, aceptas las prácticas descritas aquí.",
    "sections": [
      {
        "title": "1. Información que recolectamos",
        "groups": [
          {
            "subtitle": "Datos de cuenta",
            "items": [
              { "text": "Tu nombre y dirección de email cuando creas una cuenta." },
              { "text": "La contraseña que eliges, almacenada con hash; nunca la leemos en texto plano." },
              { "text": "Si te registras con Google o Apple, recibimos de ese proveedor tu nombre, email e identificador de usuario. No recibimos tu contraseña." }
            ]
          },
          {
            "subtitle": "Contenido que creas",
            "items": [
              { "text": "Tareas, proyectos, comentarios y archivos adjuntos que subas a la plataforma." },
              { "text": "Grabaciones de audio de reuniones, junto con las transcripciones y resúmenes generados a partir de ellas." },
              { "text": "Invitaciones a miembros del equipo, que incluyen el email del destinatario." }
            ]
          },
          {
            "subtitle": "Datos técnicos",
            "items": [
              { "text": "Tokens de notificaciones push (FCM de Google y APNs de Apple) para enviarte avisos sobre tareas y menciones." },
              { "text": "Dirección IP en los logs operativos del servidor, truncada o anonimizada; no se asocia a tu perfil de usuario." },
              { "text": "Información de errores y rendimiento de la app (detalles en la sección 3)." }
            ]
          },
          {
            "subtitle": "Datos de facturación",
            "items": [
              { "text": "Si contratas un plan de pago, el procesamiento del pago lo realiza Stripe. Nosotros no almacenamos ni vemos el número completo de tu tarjeta: únicamente guardamos el identificador de la suscripción y su estado." }
            ]
          }
        ]
      },
      {
        "title": "2. Cómo usamos tus datos",
        "items": [
          { "label": "Operación del servicio", "text": "crear y gestionar tu cuenta, proyectos, tareas y equipo." },
          { "label": "Transcripción e IA", "text": "el audio de reuniones se envía a servicios externos (ver sección 3) para generar transcripciones y extraer tareas automáticamente." },
          { "label": "Notificaciones", "text": "usar tu token push para enviarte alertas sobre asignaciones, menciones y actualizaciones de tareas." },
          { "label": "Facturación", "text": "gestionar tu suscripción, cobros y renovaciones si usas un plan de pago." },
          { "label": "Mejora del producto", "text": "analítica anonimizada de uso para entender qué funciones resultan útiles y detectar problemas." },
          { "label": "Comunicaciones de servicio", "text": "emails transaccionales sobre tu cuenta (invitaciones de equipo, cambios de contraseña, avisos importantes)." }
        ],
        "footer": "No usamos tus datos para publicidad de terceros ni los cedemos con fines comerciales ajenos al servicio."
      },
      {
        "title": "3. Servicios de terceros",
        "body": "Para operar Tworks compartimos datos específicos con los siguientes procesadores, bajo acuerdos de tratamiento de datos:",
        "items": [
          { "label": "Groq Inc.", "text": "transcripción de audio con el modelo Whisper. Recibe el archivo de audio de la reunión durante el proceso y no lo retiene más allá del tiempo necesario.", "href": "https://groq.com/privacy-policy/", "link_label": "Ver política" },
          { "label": "Anthropic PBC", "text": "extracción automática de tareas con Claude. Recibe únicamente la transcripción de texto, no el audio.", "href": "https://www.anthropic.com/legal/privacy", "link_label": "Ver política" },
          { "label": "Stripe, Inc.", "text": "procesamiento de pagos y gestión de suscripciones. Recibe tus datos de facturación directamente; no pasan por nuestros servidores.", "href": "https://stripe.com/privacy", "link_label": "Ver política" },
          { "label": "Sentry", "text": "reporte y diagnóstico de errores. Puede capturar trazas de pila y metadatos de dispositivo cuando ocurre un fallo.", "href": "https://sentry.io/privacy/", "link_label": "Ver política" },
          { "label": "PostHog", "text": "analítica de uso anonimizada (eventos de navegación, funciones utilizadas). No incluye contenido de tareas ni datos personales identificables.", "href": "https://posthog.com/privacy", "link_label": "Ver política" },
          { "label": "Google Firebase Cloud Messaging y Apple Push Notification Service", "text": "entrega de notificaciones push en dispositivos Android e iOS respectivamente." },
          { "label": "Infraestructura de alojamiento", "text": "nuestros servidores, donde se almacenan la base de datos, los archivos adjuntos y las grabaciones de audio." }
        ],
        "footer": "Cookies: usamos cookies técnicas para mantener tu sesión iniciada. Salvo que indiques lo contrario, también usamos PostHog (analítica anónima) y Sentry (reporte de errores). No usamos cookies de marketing ni de remarketing. No vendemos tus datos a terceros para ningún fin."
      },
      {
        "title": "4. Retención y eliminación",
        "callout": "Grabaciones de reuniones: el audio se borra automáticamente a los 90 días contados desde que se procesa. Puedes adelantar la eliminación en cualquier momento desde la lista de reuniones dentro de la app.",
        "items": [
          { "label": "Cuenta y contenido", "text": "se conservan mientras la cuenta esté activa. Al eliminar tu cuenta, todos los datos asociados se borran en un plazo máximo de 30 días." },
          { "label": "Transcripciones y resúmenes", "text": "se eliminan junto con la reunión correspondiente, ya sea manualmente o por el borrado automático de 90 días." },
          { "label": "Logs operativos", "text": "se retienen 30 días y luego se purgan automáticamente." },
          { "label": "Tokens push", "text": "se eliminan al cerrar sesión o borrar la cuenta." },
          { "label": "Datos de facturación", "text": "las facturas se conservan el tiempo que exija la normativa fiscal aplicable, incluso tras cerrar la cuenta." }
        ]
      },
      {
        "title": "5. Tus derechos",
        "body": "Dependiendo de tu jurisdicción, puedes ejercer los siguientes derechos sobre tus datos personales:",
        "items": [
          { "label": "Acceso", "text": "consultar qué información tenemos sobre ti desde la app." },
          { "label": "Corrección", "text": "actualizar tu nombre y email en cualquier momento desde los ajustes de perfil." },
          { "label": "Eliminación", "text": "borrar tu cuenta desde Ajustes → Zona peligrosa dentro de la app. La eliminación es permanente e irreversible." },
          { "label": "Exportación", "text": "solicitar una copia de tus datos escribiéndonos por correo. La exportación automática desde la app aún no está disponible." },
          { "label": "Oposición o limitación", "text": "puedes solicitar que dejemos de procesar tus datos para determinados fines contactándonos directamente." }
        ],
        "footer": "Respondemos a las solicitudes en un plazo máximo de 30 días. Si tienes dudas sobre el tratamiento de tus datos, tienes derecho a presentar una reclamación ante la autoridad de protección de datos de tu país."
      },
      {
        "title": "6. Seguridad",
        "body": "Aplicamos medidas técnicas y organizativas razonables para proteger tus datos: cifrado en tránsito (HTTPS/TLS), tokens de sesión seguros y acceso restringido a los datos de producción. Ningún sistema es infalible; si detectas una vulnerabilidad, te pedimos que la reportes por correo antes de divulgarla públicamente."
      },
      {
        "title": "7. Transferencias internacionales",
        "body": "Algunos de los servicios mencionados (Groq, Anthropic, Stripe, Sentry, PostHog, Google, Apple) procesan datos en servidores ubicados fuera de tu país de residencia. Estos proveedores cuentan con mecanismos de transferencia adecuados según la normativa aplicable. Estamos en proceso de cumplimiento con el RGPD (Unión Europea), la LFPDPPP (México) y la LGPD (Brasil), según corresponda al usuario."
      },
      {
        "title": "8. Niños y menores",
        "body": "Tworks no está dirigido a personas menores de 13 años ni recopila intencionalmente datos de menores. Si eres padre, madre o tutor y crees que tu hijo ha proporcionado datos personales, contáctanos para proceder a su eliminación inmediata."
      },
      {
        "title": "9. Cambios a esta política",
        "body": "Podemos actualizar esta política para reflejar cambios en el producto o en la legislación aplicable. Te notificaremos por email con al menos 15 días de antelación ante cambios materiales. La fecha al inicio del documento indica la versión vigente."
      }
    ],
    "contact_title": "10. Contacto",
    "contact_body": "Si tienes preguntas, solicitudes o inquietudes sobre el tratamiento de tus datos, escríbenos a:",
    "contact_email": "privacidad{'@'}moniteck.com",
    "contact_footer": "Haremos todo lo posible por responderte en un plazo de 5 días hábiles.",
    "back": "Volver al inicio"
  },
  "terms": {
    "title": "Términos del servicio",
    "last_updated": "Última actualización: enero 2026",
    "intro": "Al usar Tworks aceptas estos términos. Léelos con calma.",
    "section_1_title": "Cuenta",
    "section_1_body": "Eres responsable de mantener segura tu contraseña y de la actividad de tu cuenta. Debes tener al menos 18 años para crear una cuenta.",
    "section_2_title": "Uso aceptable",
    "section_2_body": "No uses Tworks para actividades ilegales, spam, malware ni para acosar a otros usuarios. Nos reservamos el derecho de suspender cuentas que violen estos términos.",
    "section_3_title": "Pagos y cancelación",
    "section_3_body": "Los planes de pago se facturan por adelantado (mensual o anual). Cancelas cuando quieras desde Billing — al cancelar Pro, vuelves a Free sin perder datos. No hay reembolsos por períodos parciales.",
    "section_4_title": "Tu contenido",
    "section_4_body": "Tu contenido sigue siendo tuyo. Nos otorgas una licencia limitada para procesarlo y mostrarlo según operes el servicio (por ejemplo, transcribir reuniones, sincronizar tareas).",
    "section_5_title": "Servicio \"tal cual\"",
    "section_5_body": "Hacemos lo posible por mantener Tworks estable y disponible, pero el servicio se ofrece \"tal cual\" sin garantías. No nos hacemos responsables por daños indirectos derivados del uso.",
    "section_6_title": "Cambios",
    "section_6_body": "Podemos actualizar estos términos. Te avisaremos por email con 30 días de anticipación si los cambios son materiales.",
    "section_7_title": "Contacto",
    "section_7_body": "hola{'@'}pavemi.com",
    "back": "Volver al inicio"
  },
  "changelog": {
    "kicker": "Changelog",
    "title": "Novedades",
    "intro": "Lo que hemos lanzado y mejorado en Tworks, mes a mes.",
    "badge_new": "Nuevo",
    "badge_imp": "Mejora",
    "badge_fix": "Corrección",
    "back": "Volver al inicio",
    "releases": [
      {
        "period": "Julio 2026",
        "items": [
          {
            "type": "new",
            "text": "Subtareas con responsable propio: asigna cada subtarea a una persona distinta."
          },
          {
            "type": "new",
            "text": "Una tarea en varios proyectos: aparece en todos los tableros donde la vincules, con su estado sincronizado."
          },
          {
            "type": "new",
            "text": "Tablero personal en Mis tareas, con columnas propias que tú defines."
          },
          {
            "type": "new",
            "text": "Proyectos y equipos favoritos para llegar más rápido a lo que usas a diario."
          },
          {
            "type": "imp",
            "text": "Cambio de workspace más claro e intuitivo."
          }
        ]
      },
      {
        "period": "Junio 2026",
        "items": [
          {
            "type": "new",
            "text": "Comparte cualquier tarea con un enlace directo."
          },
          {
            "type": "new",
            "text": "Te notificamos cuando alguien completa una tarea que creaste."
          },
          {
            "type": "imp",
            "text": "Renombra las columnas de tu tablero personal."
          },
          {
            "type": "imp",
            "text": "El reporte PDF ahora incluye las últimas tareas terminadas."
          }
        ]
      },
      {
        "period": "Mayo 2026",
        "items": [
          {
            "type": "new",
            "text": "Workspaces múltiples: crea espacios separados y cambia entre ellos sin salir de la app."
          },
          {
            "type": "new",
            "text": "App para Android (descarga directa desde el sitio)."
          },
          {
            "type": "imp",
            "text": "Mejoras de estabilidad y rendimiento en toda la app."
          }
        ]
      },
      {
        "period": "Abril 2026",
        "items": [
          {
            "type": "new",
            "text": "Reuniones con IA: graba desde el navegador, obtén transcripción y resumen, y convierte los acuerdos en tareas con un click."
          },
          {
            "type": "new",
            "text": "Planes Pro y Business, con 14 días de Pro gratis al registrarte."
          },
          {
            "type": "imp",
            "text": "Rediseño completo de la vista de reuniones."
          }
        ]
      }
    ]
  },
  "security": {
    "title": "Seguridad",
    "last_updated": "Última actualización: julio 2026",
    "intro": "Cómo protegemos los datos de tu equipo en Tworks, desde la conexión hasta el almacenamiento.",
    "section_1_title": "Cifrado en tránsito",
    "section_1_body": "Toda la comunicación entre tu navegador (o la app móvil) y nuestros servidores viaja cifrada con TLS.",
    "section_2_title": "Autenticación y acceso",
    "section_2_body": "Las contraseñas se guardan hasheadas — nunca en texto plano. Puedes iniciar sesión con Google. Las sesiones usan tokens revocables y las llaves de la API pública tienen permisos limitados por alcance, confinados a la API v1.",
    "section_3_title": "Aislamiento por equipos",
    "section_3_body": "Tworks es multi-tenant: cada solicitud valida que pertenezcas al equipo y al proyecto que intentas ver. Los datos de un workspace nunca se mezclan con los de otro.",
    "section_4_title": "Audio de reuniones",
    "section_4_body": "El audio de tus reuniones se guarda en almacenamiento privado, sin URLs públicas, y se borra automáticamente a los 90 días (configurable por equipo). Los proveedores que procesan transcripciones están listados en nuestra política de privacidad.",
    "section_5_title": "Infraestructura",
    "section_5_body": "Tus datos se almacenan en PostgreSQL con acceso restringido a la aplicación, siguiendo el principio de mínimo privilegio.",
    "section_6_title": "Reporta una vulnerabilidad",
    "section_6_body": "¿Encontraste un problema de seguridad? Escríbenos a hola{'@'}pavemi.com. Agradecemos la divulgación responsable y respondemos a la brevedad.",
    "back": "Volver al inicio"
  }
}
